const hasEmptyResults = (pageResults, suggestions, vehicles) => {
	return (
		(Array.isArray(pageResults) && pageResults?.length === 0) ||
		(Array.isArray(suggestions) && suggestions?.length === 0) ||
		(Array.isArray(vehicles) && vehicles?.length === 0)
	);
};

export default hasEmptyResults;
